import * as React from "react";
import { style, keyframes } from "typestyle";
import { colors } from "styles/styles";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" }
});

const classname = style({
  borderRadius: "50%",
  borderColor: "transparent",
  borderStyle: "solid",
  animationName: spin,
  animationDuration: "0.5s",
  animationIterationCount: "infinite",
  animationTimingFunction: "linear"
});

const colorOptions = {
  blue: style({ borderTopColor: colors.hooplaBlue }),
  white: style({ borderTopColor: "white" })
};

const sizeOptions = {
  small: style({ borderWidth: 2, width: 14, height: 14 }),
  mediumsmall: style({ borderWidth: 2.5, width: "2.3rem", height: "2.3rem" }),
  medium: style({ borderWidth: 3, width: "5rem", height: "5rem" }),
  large: style({ borderWidth: 4, width: "8rem", height: "8rem" })
};

interface IProps {
  color?: "blue" | "white";
  size?: "small" | "mediumsmall" | "medium" | "large";
}

const Loading: React.FunctionComponent<IProps> = ({ color, size }) => (
  <div className={`${classname} ${sizeOptions[size]} ${colorOptions[color]}`} />
);

Loading.defaultProps = {
  color: "blue",
  size: "medium"
};

const containerStyles = style({
  height: "20rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

export const ContainerLoader: React.FunctionComponent = () => (
  <div className={containerStyles}>
    <Loading />
  </div>
);

export default Loading;
